import { onExcelTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ExcelTemplateActivityCard } from "./ExcelTemplateActivityCard";

interface Props {
  excelTemplateId: number
  config: server.dto.ActivityPanelConfig
}

export const ExcelTemplateActivityPanel = (props: Props) => {

  return <ActivityPanel<server.dto.ExcelTemplateActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ExcelTemplate.ListActivity({ itemId: props.excelTemplateId, page, perPage })}
    renderActivity={(activity => <ExcelTemplateActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onExcelTemplateActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.excelTemplateId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}